import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 CORÉEN EXPRESS™',
  ideal: 'Toute personne qui souhaite comprendre le coréen depuis zéro, sans avoir étudié de langues auparavant',
  was: '54€',
  now: '19€',
  features: ['6 Tomes Complets (120+ pages)', 'Hangeul depuis zéro, expliqué visuellement', 'Vraies expressions K-Drama & K-Pop', 'Routine de 60 minutes avec progrès visible', '5 Bonus Gratuits inclus', 'Garantie de satisfaction 7 jours', 'Accès à vie & mises à jour gratuites'],
  cta: 'Obtenir Coréen Express'
};
const trust = [{
  icon: LockIcon,
  label: 'Paiement 100% Sécurisé'
}, {
  icon: ZapIcon,
  label: 'Accès Instantané'
}, {
  icon: CreditCardIcon,
  label: 'Carte de Crédit / Débit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Tarifs" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-128" data-mp="3vynh8bvjpr9c">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" data-id="element-129" data-mp="4ruh7bchny6e">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(124,58,237,0.45)]" data-id="element-130" data-mp="9sia62ka2p39">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-131" data-mp="3n524sz6usm33">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-132" data-mp="3rz6azg8aoq34">
            <span className="font-semibold text-plum/80" data-id="element-133" data-mp="2uizj1lyxk0k4">Idéal pour :</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-134" data-mp="2zgr90ag0lclo">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-135" data-mp="2zfzpvz3lt7ca">{plan.was}</span>
            <div className="text-grape-shine font-display text-4xl font-black" style={{
            fontSize: "64px",
            paddingBottom: "26px",
            fontFamily: "Cinzel, serif",
            paddingTop: "20px"
          }} data-id="element-136" data-mp="2rei9cchv6dp2">{plan.now}</div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-137" data-mp="318qx6mvy9igw">
              Paiement unique · Accès illimité
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-138" data-mp="28hqs08lvu8nn">
              Le paiement sera traité dans votre devise locale.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-139" data-mp="23l0glyl0w18k">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-140" data-mp="2ihhqeldkd7t0">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-141" data-mp="2dfilv86384uh" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-142" data-mp="3ow8tmvq5t4q7">
            <CTAButton size="md" data-id="element-143" data-mp="3ovz4facxv1lk">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-144" data-mp="9c7ygel2wyn">
            Vous économisez 35€ (65% de réduction)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-145" data-mp="573zh9bbgh2b">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-146" data-mp="3rihzolt7aeru">
                <Icon className="h-4 w-4 text-grape" data-id="element-147" data-mp="j1n6xz64aarh" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-148" data-mp="a8jk509l0lk6" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-149" data-mp="a9cuscbnvv7l">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-150" data-mp="e8bu9hemizrn" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-151" data-mp="11yxvaoq7njs5">
            <span className="font-display font-bold text-plum" data-id="element-152" data-mp="16qzekulsqaro">
              🛡️ Garantie de satisfaction 7 jours.
            </span>{' '}
            Si dans les 7 premiers jours vous pensez que l'ebook ne correspond pas à ce dont vous
            avez besoin ou ne vous donne pas l'impulsion que vous recherchiez, demandez votre
            remboursement et nous vous restituons 100% de votre argent. Nous voulons que vous
            appreniez en toute tranquillité, sans risque.
          </p>
        </div>
      </div>
    </section>;
}